<template>
  <div class="row g-3 mb-4">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'KPISection'
}
</script>
